import {$notificationProvider} from '../providers';

export const TASK_STARTED = 'TASK_STARTED';
export const TASK_DONE = 'TASK_DONE';
export const RESET = 'RESET';

function taskStarted() {
  return {
    type: TASK_STARTED,
    payload: {}
  };
}

function taskDone() {
  return {
    type: TASK_DONE,
    payload: {}
  };
}

function reset() {
  return {
    type: RESET,
    payload: {}
  };
}

function taskSucceeded(msg = 'Opération réalisée') {
  $notificationProvider().success(msg);
  return taskDone();
}

function taskFailed(msg = 'Une erreur est survenue') {
  $notificationProvider().error(msg);
  return taskDone();
}

export default {
  reset,
  taskStarted,
  taskFailed,
  taskSucceeded,
  taskDone
};



// WEBPACK FOOTER //
// ./src/actions/general.actions.js